// Centralized Query Key Factories

export const QUERY_KEYS = {
	// User & Profile keys
	user: {
		profile: (userId: string) => ["user", "profile", userId] as const,
		festivals: (userId: string) => ["user", "festivals", userId] as const,
		stats: (userId: string) => ["user", "stats", userId] as const,
		reviews: (userId: string, festivalId?: string) =>
			festivalId
				? (["user", "reviews", userId, festivalId] as const)
				: (["user", "reviews", userId] as const),
		publicProfile: (username: string) =>
			["user", "public-profile", username] as const,
		currentUser: () => ["user", "current"] as const,
		displayName: (userId: string) => ["user", "display-name", userId] as const,
	},

	// Festival keys
	festival: {
		data: (slug: string) => ["festival", "data", slug] as const,
		reviews: (festivalId: string, userId?: string) =>
			userId
				? (["festival", "reviews", festivalId, userId] as const)
				: (["festival", "reviews", festivalId] as const),
		sets: (festivalId: string) => ["festival", "sets", festivalId] as const,
		userReview: (festivalId: string, userId: string) =>
			["festival", "user-review", festivalId, userId] as const,
		list: (filters?: object) => ["festival", "list", filters] as const,
		// Note: attendance facepile moved to server actions with query key: ["festival-facepile", festivalIds]
	},

	// Social keys
	social: {
		notifications: (userId: string) =>
			["social", "notifications", userId] as const,
		follows: (userId: string, type: "followers" | "following") =>
			["social", "follows", userId, type] as const,
		followStatus: (followerId: string, followedId: string) =>
			["social", "follow-status", followerId, followedId] as const,
		followStats: (userId: string) =>
			["social", "follow-stats", userId] as const,
		invites: (userId: string) => ["social", "invites", userId] as const,
		inviteStats: (userId: string) =>
			["social", "invite-stats", userId] as const,
		socialInteractions: (festivalSlug: string) =>
			["social", "interactions", festivalSlug] as const,
		profileSocial: (username: string, viewerUserId?: string) =>
			viewerUserId
				? (["social", "profile", username, viewerUserId] as const)
				: (["social", "profile", username] as const),
	},

	// Search keys
	search: {
		artists: (query: string) => ["search", "artists", query] as const,
		festivals: (filters: object) => ["search", "festivals", filters] as const,
		users: (query: string) => ["search", "users", query] as const,
		general: (query: string) => ["search", "general", query] as const,
	},

	// Auth keys
	auth: {
		session: () => ["auth", "session"] as const,
		emailAvailability: (email: string) =>
			["auth", "email-availability", email] as const,
		usernameAvailability: (username: string) =>
			["auth", "username-availability", username] as const,
	},

	// Account management keys
	account: {
		settings: (userId: string) => ["account", "settings", userId] as const,
		privacy: (userId: string) => ["account", "privacy", userId] as const,
		password: (userId: string) => ["account", "password", userId] as const,
	},
} as const;
